import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import How_to_Authenticate from '../components/Authenticity/How_to_Authenticate';
import Certified_Lab_Report from '../components/Authenticity/Certified_Lab_Report';
import Project_Protein from '../components/Authenticity/Project_Protein';
import Non_VerifiedSupplements from '../components/Authenticity/Non_VerifiedSupplements';
import Who_is_NutriCheck from '../components/Authenticity/Who_is_NutriCheck';
import Project_Protein_performance from '../components/Authenticity/Project_protein_performance';
import The_authentication_factor from '../components/Authenticity/The_authentication_factor';

export default function Authenticity() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // animate only once
      disable: window.innerWidth < 768,
    });
  }, []);
  return (
    <div>
      <Navbar />

      <How_to_Authenticate />
      
      <The_authentication_factor />
      {/* Banner */}
     {/* ==================== AUTHENTICITY HERO SECTION ==================== */}

      <Certified_Lab_Report />

      {/* BANNER */}
     <section 
  className="position-relative overflow-hidden"
  style={{
    backgroundImage: `url('/assets/images/Family-Poster-2.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '520px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  }}
>
  {/* Dark Overlay */}
  <div 
    className="position-absolute top-0 start-0 w-100 h-100"
    style={{ 
      backgroundColor: 'rgba(0, 0, 0, 0.55)'
    }}
  />

  <div className="container position-relative" style={{ zIndex: 2 }}>
    <div className="row justify-content-center text-center">
      <div className="col-lg-10 col-xl-9">
        <div className="py-5 py-lg-6 text-center">
          
          <h1 
            className="text-white fw-bold mb-3"
            style={{ 
              fontSize: 'clamp(2rem, 5vw, 3.5rem)', 
              lineHeight: '1.2',
              textShadow: '0 3px 10px rgba(0,0,0,0.6)'
            }}
          >
            Verify Product Authenticity
          </h1>

          <p 
            className="text-white fs-4 mb-4 mx-auto"
            style={{ 
              maxWidth: '680px', 
              opacity: '0.95',
              fontSize: 'clamp(1rem, 4vw, 1.25rem)'
            }}
          >
            Enter your batch number to instantly check if your Evercore product is genuine and authentic.
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* Bottom Curve / White Transition */}
  <div 
    className="position-absolute bottom-0 start-0 w-100"
    style={{
      height: '120px',
      background: 'linear-gradient(to bottom, transparent, #ffffff)',
    }}
  />
</section>

      <Project_Protein />

      <Non_VerifiedSupplements />

   
      <Project_Protein_performance />

      <Footer />
    </div>
  );
}
